import { IComponentOptions, IQService } from 'angular';
import {
    StateParams,
    StateService,
    Transition,
    TransitionService,
} from 'angular-ui-router';
import {
    FONT_CATEGORY_OPTIONS,
    FONT_POSTURE_OPTIONS,
    FONT_WEIGHT_OPTIONS,
    FONT_WIDTH_OPTIONS,
    FontCategory,
    FontListParams,
    FontListParamsStateParamsResolver,
    FontListParamsToStateParams,
    FontPosture,
    FontWeight,
    FontWidth,
    Option,
} from '../../tn.common';
import { IFavoriteList } from '../favorites-repository.service/favoritesRepository';
import template from './favorites-detail-sidebar.html';

export class FavoritesDetailSidebar {
    // bindings
    favorite?: IFavoriteList;
    filters: FontListParams = {};

    // locals
    categories: Option<FontCategory>[] = [];
    postures: Option<FontPosture>[] = [];
    weights: Option<FontWeight>[] = [];
    widths: Option<FontWidth>[] = [];

    onStateParamsChangedDebounceTimeout?: number;

    static $inject = [
        '$q',
        '$state',
        '$stateParams',
        '$transitions',
        'tn.people.service',
    ];

    constructor(
        protected $q: IQService,
        protected $state: StateService,
        protected $stateParams: StateParams,
        protected $transitions: TransitionService
    ) {
        const onTransitionSuccess = (transition: Transition) => {
            const params = transition.params();
            this.onStateParamsChanged(params);
        };
        $transitions.onSuccess(
            { to: 'home.account.favorites.favorite' },
            onTransitionSuccess
        );
    }

    $onInit(): void {
        this.onStateParamsChanged(this.$stateParams);
    }

    onStateParamsChanged(params: Partial<StateParams>): void {
        this.filters = FontListParamsStateParamsResolver(params);
        if (this.onStateParamsChangedDebounceTimeout) {
            window.clearTimeout(this.onStateParamsChangedDebounceTimeout);
        }
        this.onStateParamsChangedDebounceTimeout = window.setTimeout(() => {
            this.onStateParamsChangedDebounceTimeout = undefined;
            this.getData();
        }, 300);
    }

    getData(): void {
        const favorite = this.favorite;
        if (!favorite) return;
        this.categories = FONT_CATEGORY_OPTIONS.filter((option) =>
            favorite.style.some((style) =>
                style.category.includes(option.value)
            )
        );
        this.postures = FONT_POSTURE_OPTIONS.filter((option) =>
            favorite.style.some((style) => style.posture === option.value)
        );
        this.weights = FONT_WEIGHT_OPTIONS.filter((option) =>
            favorite.style.some((style) => style.weight === option.value)
        );
        this.widths = FONT_WIDTH_OPTIONS.filter((option) =>
            favorite.style.some((style) => style.width === option.value)
        );
    }

    modifyState(params: Partial<FontListParams>): void {
        const stateParams = FontListParamsToStateParams({
            ...this.filters,
            ...params,
        });
        // console.log('FavoritesDetailSidebar.modifyState', stateParams);
        this.$state.go('.', stateParams);
    }

    clearFilters(): void {
        this.$state.go(
            '.',
            { favoriteId: this.favorite?.id },
            { inherit: false }
        );
    }

    clearFilter(filter: string): void {
        delete this.filters[filter];
        const stateParams = FontListParamsToStateParams(this.filters);
        this.$state.go('.', stateParams);
    }

    hasFilter(key: keyof FontListParams, value: unknown): boolean {
        const filter = this.filters[key];
        if (filter == undefined) return false;
        if (value == undefined) {
            return Array.isArray(filter) ? filter.length > 0 : filter !== '';
        }
        return Array.isArray(filter)
            ? (filter as unknown[]).includes(value)
            : filter === value;
    }
}

export const FavoritesDetailSidebarComponent: IComponentOptions = {
    bindings: {
        favorite: '<',
        filters: '<',
    },
    controller: FavoritesDetailSidebar,
    controllerAs: 'vm',
    template,
};
